'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var teachers = exports.teachers = {
  title: 'Profesores',
  description: 'Hazte profesor y enseña al mundo tus habilidades, ganando dinero',
  background_url: 'https://dev-res.thumbr.io/images/teachers-banner.jpg?brightness=-30&gamma=0.8',
  reasons_title: 'Ventajas de ser Profesor',
  reasons: JSON.stringify(['make', 'branding', 'profit']),
  make_title: 'Graba tu propio curso',
  make_description: 'Utiliza una cámara, webcam o teléfono. Grábate en pequeñas píldoras. Cuida el sonido y edita el resultado. Te enseñaremos a hacerlo.',
  make_icon: 'https://lib.tutellus.com/images/icons/record.svg',
  branding_title: 'Refuerza tu marca personal',
  branding_description: 'Escribe en tu propio Blog de Tutellus. Crea un espacio único. Nos encargaremos de promocionarlo para que consigas usuarios.',
  branding_icon: 'https://lib.tutellus.com/images/icons/brand.svg',
  profit_title: 'Gana dinero enseñando',
  profit_description: 'Te damos todas las herramientas para que publiques y difundas tu curso sin costes. Y el 70% de las ventas irá para tí, siempre.',
  profit_icon: 'https://lib.tutellus.com/images/icons/earn-money.svg',
  become_teacher: 'Hazte Profesor',
  metrics_title: 'Métricas de tus Cursos',
  metrics_description: 'Analiza las principales Métricas de tus cursos (Conversión, Recurrencia, Avance...) y saca tus propias conclusiones para mejorar la relación tanto con Alumnos como con los potenciales.',
  metrics_image: 'https://dev-res.thumbr.io/images/teachers-metrics.png',
  profits_title: 'Controla tus Beneficios',
  profits_description: 'Tienes un servicio de "Monedero" con el que analizar tus ganancias y estudiar qué canales te funcionan mejor en cada curso, para priorizarlos.',
  profits_image: 'https://dev-res.thumbr.io/images/teachers-profits.jpg',
  profits_pic: 'https://dev-res.thumbr.io/images/teachers-profits-notebook.jpg',
  promotions_title: 'Cupones, Afiliados y Promos',
  promotions_description: 'Haz uso de los diferentes servicios que ponemos a tu disposición para que potencies tu Comunidad y encuentres más usuarios interesados en tus cursos. Cuanto más lo uses, mejor te funcionarán.',
  promotions_image: 'https://dev-res.thumbr.io/images/teachers-promotion.jpg',
  community_title: 'Interacción con tu Comunidad',
  community_description: 'Cada curso es un universo propio donde tienes alumnos deseando interactuar contigo. Ayúdales en su día a día y te ayudarán mediante el sistema de recomendaciones, a conseguir nuevos usuarios.',
  community_image: 'https://dev-res.thumbr.io/images/teachers-interaction.jpg',
  testimonials_title: 'Nuestros profesores opinan sobre Tutellus',
  testimonials: JSON.stringify(['sergio', 'david', 'dany', 'eva']),
  sergio_pic: 'https://lib.tutellus.com/images/people/sergio-fernandez.jpg',
  sergio_name: 'Sergio Fernández',
  sergio_job: 'Emprendedor',
  sergio_testimonial: 'Me encanta Tutellus porque está revolucionando la forma que tenemos de aprender y enseñar. Es fácil, intuitivo y su equipo de soporte es rápido y eficaz. Sin duda, la mejor plataforma que conozco. 100% recomendable',
  david_pic: 'https://lib.tutellus.com/images/people/david-sevilla.jpg',
  david_name: 'David Sevilla',
  david_job: 'Programador',
  david_testimonial: 'Me enteré de Tutellus por mi madre, y como vívía en Madrid un día fui a sus oficinas. Me han ayudado mucho a preparar el curso de Programación, y algún día me gustaría llegar a programar tan bien como Javier Ortiz.',
  dany_pic: 'https://lib.tutellus.com/images/people/dany-campos.jpg',
  dany_name: 'Dany Campos',
  dany_job: 'Guionista',
  dany_testimonial: 'Tutellus me proporciona la herramienta para poder llegar con mi contenido a cualquier usuario. Gracias a su interfaz como a las personas que lo hacen funcionar, puedo decir que ya tengo un sobresueldo cada mes!',
  eva_pic: 'https://lib.tutellus.com/images/people/eva-garcia.jpg',
  eva_name: 'Eva García',
  eva_job: 'Escritora',
  eva_testimonial: 'En Tutellus he encontrado la herramienta perfecta para lanzar el curso que me interesaba y alcanzar a potenciales alumnos. A destacar lo fácil que resulta utilizar la plataforma, servicios, cupones y mucho más.'
};


//////////////////
// WEBPACK FOOTER
// ../i18n/lib/es/teachers.js
// module id = 704
// module chunks = 0